<template>
  <div class="card">
    <slot name="header">
      <div class="clearfix header">
        <div v-if="title || subTitle" class="pull-left title">
          <span v-if="title">{{ title }}</span>
          <span v-if="subTitle" class="note" v-html="subTitle" />
        </div>
        <div class="pull-left tabs" v-if="$slots.tabs">
          <slot name="tabs" />
        </div>
        <div class="pull-right extra" v-if="$slots.extra">
          <slot name="extra" />
        </div>
      </div>
    </slot>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
export default {
  props: {
    title: String,
    subTitle: String,
  },
};
</script>
